import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';

export const FUSE_LOADING_BAR_SKIP_HEADER = 'X-Fuse-Loading-Bar-Skip';

@Injectable()
export class FuseLoadingInterceptor implements HttpInterceptor
{
    handleRequestsAutomatically: boolean;

    /**
     * Constructor
     */
    constructor(
        private _fuseLoadingService: FuseLoadingService
    )
    {
        // Subscribe to the auto
        this._fuseLoadingService.auto$
            .subscribe((value) => {
                this.handleRequestsAutomatically = value;
            });
    }

    /**
     * Intercept
     *
     * @param req
     * @param next
     */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        const skipLoadingBar = req.headers.has(FUSE_LOADING_BAR_SKIP_HEADER);
        const request = skipLoadingBar
            ? req.clone({ headers: req.headers.delete(FUSE_LOADING_BAR_SKIP_HEADER) })
            : req;

        // If the Auto mode is turned off, do nothing
        if ( !this.handleRequestsAutomatically || skipLoadingBar )
        {
            return next.handle(request);
        }

        // Set the loading status to true
        this._fuseLoadingService._setLoadingStatus(true, request.url);

        return next.handle(request).pipe(
            finalize(() => {
                // Set the status to false if there are any errors or the request is completed
                this._fuseLoadingService._setLoadingStatus(false, request.url);
            }));
    }
}
